<template>
  <div id="app" class="initial">
    <!-- 暂不明确控制管理页面和首页的对立条件 -->
    <template v-if="this.$route.fullPath.substring(1, 6)=='admin'">
      <router-view></router-view>
    </template>
    <template v-else-if="$route.path=='/login_gate'">
      <router-view></router-view>
    </template>
    <template v-else>
      <mod-header></mod-header>
      <!-- keep-alive Vue内置组件，防止dom重新渲染 -->
      <keep-alive>
        <router-view v-if='$route.meta.keepAlive' />
      </keep-alive>
      <router-view v-if='!$route.meta.keepAlive'></router-view>
      <mod-footer></mod-footer>
      <global-nav v-if="btnFlag" class="nav"></global-nav>
    </template>
  </div>
</template>
<script>
import * as gettersType from '@/store/getters/type';
// import modHeader from './common/area/header';
import modHeader from './pages/views/header/header';
import modFooter from './common/area/footer';
import globalHome from './common/area/home';
import globalNav from './common/area/right-nav';
export default {
  data() {
    return {
      btnFlag: false,
      gettersType,
      scrollTop: 0
    };
  },
  created() {
    window.onload = function() {
      document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener('gesturestart', function(event) {
        event.preventDefault();
      });
    };
  },
  components: {
    modHeader,
    modFooter,
    globalHome,
    globalNav
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop);
  },
  methods: {
    scrollToTop() {
      // 为了计算距离顶部的高度，当高度大于240显示回顶部图标，小于240则隐藏
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 240) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.nav {
  position: fixed;
  bottom: 100px;
  right: 100px;
  z-index: 90;
}

.initial {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue